export function useQuerySet<T = Indexable>(
  groupId: number | null = null,
  url: string | null = null
) {
  const data = ref<T>();
  const status = ref<"idle" | "loading" | "error" | "success">("idle");
  const error = ref<Error | null>(null);
  const querySetGroupId = ref<number | null>(groupId);
  const filters = ref<Indexable>({});
  const context = ref<Indexable>({});
  const pageNumber = ref<number>(1);
  const pageSize = ref<number>(20);

  async function fetchData() {
    // Only report "loading" on the very first fetch. Consumers swap the rendered slot out for a
    // spinner while loading, so flipping to it on every refresh made panels flicker on each
    // keystroke once the context watcher started firing correctly. Keeping the previous data on
    // screen while a refresh is in flight avoids that.
    if (data.value === undefined) {
      status.value = "loading";
    }
    error.value = null;

    try {
      const response = await $fetch(
        url ? url : `/scad/v2/data/queryset/${querySetGroupId.value}`,
        {
          retry: 0,
          query: {
            Filters: JSON.stringify(filters.value),
            // Columns
            RecordContext: JSON.stringify(context.value),
            PageNumber: pageNumber.value,
            PageSize: pageSize.value,
          },
        }
      );
      data.value = response as T;
      status.value = "success";
    } catch (error: unknown) {
      status.value = "error";
      error.value = error as Error;
    }
  }

  return {
    data,
    status,
    error,
    fetchData,
    filters,
    context,
    pageNumber,
    pageSize,
    querySetGroupId,
  };
}

